// import { useParams, useNavigate } from "react-router-dom";
// import { useSelector } from "react-redux";

// const OrderDetail = () => {
//   const { orderId } = useParams(); // Get orderId from URL
//   const navigate = useNavigate();

//   // Get all orders from Redux store
//   const order = useSelector((state) =>
//     state.orders?.items?.find((item) => item.id === orderId)
//   );

//   if (!order) {
//     return (
//       <div className="flex flex-col items-center justify-center h-screen">
//         <p className="text-xl font-semibold text-red-600">Order not found!</p>
//         <button
//           onClick={() => navigate("/profile")}
//           className="mt-4 px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
//         >
//           Back to Orders
//         </button>
//       </div>
//     );
//   }

//   return (
//     <div className="max-w-3xl mx-auto p-6 bg-white shadow-lg rounded-lg mt-10">
//       <h2 className="text-2xl font-bold text-center mb-6">Order Details</h2>
//       <div className="flex space-x-6">
//         <img
//           src={order.image}
//           alt={order.name}
//           className="w-40 h-40 object-cover rounded-lg"
//         />
//         <div>
//           <p className="text-lg font-semibold">Order ID: {order.id}</p>
//           <p className="text-gray-600">{order.name}</p>
//           <p className="text-gray-500">Size: {order.size}</p>
//           <p
//             className={`text-sm font-semibold ${
//               order.status === "Delivered"
//                 ? "text-green-600"
//                 : order.status === "Shipped"
//                 ? "text-blue-600"
//                 : "text-yellow-600"
//             }`}
//           >
//             Status: {order.status}
//           </p>
//           <p className="text-xl font-bold mt-2">₹{order.price}</p>
//           <p className="text-sm text-gray-600">Payment: {order.payment}</p>
//         </div>
//       </div>
//       <button
//         onClick={() => navigate("/profile")}
//         className="mt-6 px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
//       >
//         Back to Orders
//       </button>
//     </div>
//   );
// };

// export default OrderDetail;


// import { useParams, useNavigate } from "react-router-dom";
// import { useSelector } from "react-redux";
// import { FaTruck } from "react-icons/fa"; // Icon for Shipping
// import { setBillingAddress,billingAddress } from "../../store/addressSlice";

// const OrderDetail = () => {
//   const { orderId } = useParams();
//   const navigate = useNavigate();

//   // Get order from Redux state
//   const order = useSelector((state) =>
//     state.orders?.items?.find((item) => item.id === orderId)
//   );
//   // Fix: Ensure we use billingAddress instead of undefined billingDetails
//   const { billingAddress } = useSelector((state) => state.address);
//   const userName = billingAddress?.name || "Customer"; // Fix variable name

//   if (!order) {
//     return (
//       <div className="flex flex-col items-center justify-center h-screen">
//         <p className="text-xl font-semibold text-red-600">Order not found!</p>
//         <button
//           onClick={() => navigate("/profile")}
//           className="mt-4 px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
//         >
//           Back to Orders
//         </button>
//       </div>
//     );
//   }

//   // Safe access billing details
//   const billingDetails = order?.billingDetails || { name: "Guest", email: "", phone: "" };


//   return (
//     <div className=" bg-tertiary mt-10">
//       {/* Top Section */}
//       <div className="flex items-center justify-between border-b pb-4">
//         <button
//           onClick={() => navigate("/profile")}
//           className="px-4 py-2 bg-gray-300 text-gray-800 rounded hover:bg-gray-400"
//         >
//           ← Back
//         </button>
//         <h2 className="text-2xl font-bold">Order Detail</h2>
//         <div></div> {/* Empty div to balance the layout */}
//       </div>

//       {/* Main Content */}
//       <div className="flex flex-col lg:flex-row gap-6 mt-6">
//         {/* Left Section */}
//         <div className="lg:w-1/2">
//           {/* Order Details Box */}
//           <h3 className="text-xl font-semibold mb-3">Order Details</h3>
//           <div className="border rounded-lg p-4 shadow">
//             <p className="text-sm text-gray-600">Order ID: {order.id}</p>
//             <p className="text-lg font-semibold">Thank you, {userName}!</p>
//             <p
//               className={`text-sm font-semibold mt-2 ${
//                 order.status === "Delivered"
//                   ? "text-green-600"
//                   : order.status === "Shipped"
//                   ? "text-blue-600"
//                   : "text-yellow-600"
//               }`}
//             >
//               Your order is {order.status.toLowerCase()}.
//             </p>
//             <p className="text-xs text-gray-500 mt-2">
//               COD is only available for domestic orders within India, with total
//               order value under Rs. 20,000 INR. A charge of Rs. 500 will be
//               additionally levied for COD orders.
//             </p>
//             <hr className="my-3" />
//             <div className="flex items-center gap-2 text-gray-600 text-sm">
//               <FaTruck className="text-lg text-blue-600" />
//               <p>
//                 Sign up to stay tuned about our news, coupons, new arrivals,
//                 collections, sale and more.
//               </p>
//             </div>
//           </div>

//           {/* Shipping Details Box */}
        //   <h3 className="text-xl font-semibold mt-6 mb-3">Shipping Details</h3>
        //   <div className="border rounded-lg p-4 shadow">
        //     <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        //       {/* Contact Info */}
        //       <div>
        //         <p className="text-sm font-semibold">Contact Information</p>
        //         <p className="text-gray-600">{billingDetails.name}</p>
        //         <p className="text-gray-600">{billingDetails.email}</p>
        //         <p className="text-gray-600">{billingDetails.phone}</p>
        //       </div>

        //       {/* Payment Method */}
        //       <div>
        //         <p className="text-sm font-semibold">Payment Method</p>
        //         <p className="text-gray-600">{order.payment}</p>
        //       </div>

        //       {/* Shipping & Billing Address */}
        //       {order.billingAddress === order.shippingAddress ? (
        //         <div>
        //           <p className="text-sm font-semibold">Shipping & Billing Address</p>
        //           <p className="text-gray-600">{order.shippingAddress}</p>
        //         </div>
        //       ) : (
        //         <>
        //           <div>
        //             <p className="text-sm font-semibold">Shipping Address</p>
        //             <p className="text-gray-600">{order.shippingAddress}</p>
        //           </div>
        //           <div>
        //             <p className="text-sm font-semibold">Billing Address</p>
        //             <p className="text-gray-600">{order.billingAddress}</p>
        //           </div>
        //         </>
        //       )}

        //       {/* Shipping Method */}
        //       <div>
        //         <p className="text-sm font-semibold">Shipping Method</p>
        //         <p className="text-gray-600">
        //           {order.isDomestic
        //             ? "Standard Domestic Shipping (dispatches within 12-15 business days)."
        //             : "International Shipping (varies by location)."}
        //         </p>
        //       </div>
        //     </div>
        //   </div>
        // </div>

//         {/* Right Section Placeholder */}
//         <div className="lg:w-1/2">
//           {/* Provide the design details for the right section */}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default OrderDetail;

import { useParams, useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import Navbar from "../Navbar/navbar";
import Footer from "../Footer/footer";
import FooterDoodles from "../Footer/footerDoodles";
import icons from "../../icons.config";
import { IMAGE_URL } from "../../api-urls";
import { fetchOrderDetailsByIdAPI } from "../../Providers/ordersProvider";
import { getUserProfileAPI } from "../../Providers/profileProvider";
import Lottie from "lottie-react";
import loadingAnimation from '../../Assets/loadingAnimation.json';

const OrderDetail = () => {
  const { orderId } = useParams();
  const navigate = useNavigate();
  const [order, setOrder] = useState(null);
  const [loading, setLoading] = useState(true);
    const [user, setUser] = useState(null);
    const [error, setError] = useState(null);
    

  useEffect(() => {
    const fetchOrder = async () => {
      try {
        const response = await fetchOrderDetailsByIdAPI(orderId);
        setOrder(response.items[0]);
      } catch (error) {
        console.error("Failed to fetch order:", error);
        setOrder(null);
      } finally {
        setLoading(false);
      }
    };
    fetchOrder();
  }, [orderId]);
   useEffect(() => {
      const fetchUserProfile = async () => {
        try {
          const response = await getUserProfileAPI();
          if (response?.data) {
            setUser(response.data);
          } else {
            setError(response.error || "Unexpected response format");
            console.error("Error fetching user profile:", response);
          }
        } catch (error) {
          setError("Failed to fetch user profile");
          console.error("Error fetching user profile:", error);
        }
      };
  
      fetchUserProfile();
    }, []);
  

  if (loading) {
    return (
     
            <div className="flex justify-center items-center h-[400px]">
              <Lottie animationData={loadingAnimation} loop={true} className="w-[200px] h-[200px]" />
            </div>
        
    );
  }

  if (!order) {
    return (
      <div className="flex flex-col items-center justify-center h-screen">
        <p className="text-xl font-semibold text-red-600">Order not found!</p>
        <button
          onClick={() => navigate("/profile")}
          className="mt-4 px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
        >
          Back to Orders
        </button>
      </div>
    );
  }

  const fullShippingAddress = order.shippingAddress ? `${order.shippingAddress.main_street}, ${order.shippingAddress.city}, ${order.shippingAddress.state} - ${order.shippingAddress.postal_code}, ${order.shippingAddress.country}` : "";

  const fullBillingAddress = order.billingAddress ? `${order.billingAddress.main_street}, ${order.billingAddress.city}, ${order.billingAddress.state} - ${order.billingAddress.postal_code}, ${order.billingAddress.country}` : "";

  const contactInfo = order.billingAddress ? `${order.shippingAddress.contact_information.first_name} ${order.shippingAddress.contact_information.last_name}\n${order.shippingAddress.contact_information.mobile_number}\n${order.shippingAddress.contact_information.email_id}` : "";

  return (
    <>
      <Navbar />
      <div className="pb-1 pt-36 px-10 lg:px-32 bg-tertiary text-gray-900">
        <div className="flex items-center justify-between pb-6 text-primary1">
          <button onClick={() => navigate("/profile")} className="p-2 rounded-full bg-gray-300 hover:bg-gray-400">
            <img src={icons.back} alt="back button" className="w-6 h-6" />
          </button>
          <h2 className="text-3xl font-outfit font-light text-primary1">ORDER DETAIL</h2>
          <div></div>
        </div>
        <hr className="border-secondary mb-6" />

        <div className="flex flex-col md:flex-row gap-8">
  {/* Left Section - 60% width on medium and larger screens */}
  <div className="md:w-3/5 space-y-6">
    <div className="py-4 border border-secondary rounded-xl ">
      <div className="px-6">
      <h3 className="text-2xl font-outfit font-normal mb-3">Order Summary</h3>
      <p className="text-hcolor text-base font-poppins font-medium">Order ID: {order.id}</p>
      <p className="text-primary1 font-outfit font-light text-xl">Thank You for ordering {user.first_name} {user.last_name}!</p>
      <p className={`text-sm font-semibold mt-2 text-hcolor`}>
        Your order is {order.status}.
      </p>
      </div>
     
      <div className=" text-primary1 text-sm mt-3 border-secondary border-t">
        <div className="px-6 flex items-center gap-2">
        <img src={icons.eMail} alt="Email Icon" className="w-7 h-7 mt-2" />
        <p className=" font-outfit font-light text-base mt-2">Stay tuned for updates on your order and new arrivals.</p>
        </div>
      
      </div>
    </div>

    <div className="p-6 border border-secondary rounded-xl text-primary1">
      <h3 className="text-2xl font-outfit font-normal mb-3">Shipping Details</h3>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-4">
        <div>
          <p className="text-xl font-outfit font-light">Contact Information</p>
          <p className="whitespace-pre-line text-hcolor text-base font-poppins font-normal">{contactInfo}</p>
        </div>
        <div>
          <p className="text-xl font-outfit font-light">Shipping Address</p>
          <p className="text-hcolor text-base font-poppins font-normal">{fullShippingAddress}</p>
        </div>
        <div>
          <p className="text-xl  font-outfit font-light">Billing Address</p>
          <p className=" text-hcolor text-base font-poppins font-normal">{fullBillingAddress}</p>
        </div>
        <div>
          <p className=" font-outfit font-light text-xl">Payment Method</p>
          <p className="text-hcolor text-base font-poppins font-normal">{order.paymentMethod}</p>
        </div>
      </div>
    </div>
  </div>

  {/* Right Section - 40% width on medium and larger screens */}
  <div className="md:w-2/5  border border-secondary rounded-xl ">
    <div className=" bg-white py-5 px-6 ">
      <h3 className="text-2xl font-outfit font-normal mb-3">Order Items</h3>
      <div className="max-h-60 overflow-y-auto ">
        {order.items.length > 0 ? order.items.map((item, index) => (
  <div key={index} className="flex flex-row md:items-center  space-y-0 space-x-4 pb-4">
    <img src={IMAGE_URL + item.variant_thumbnail_images[0]} alt={item.name} className="w-20 h-28" />
    
    <div className="flex-1">
      <p className="text-base md:text-lg lg:text-xl font-outfit font-light text-primary1">{item.name.toUpperCase()}</p>
      <p className="text-hcolor text-sm lg:text-base">Size: {item.selectedSize || "Your Custom Size"}</p>
      <p className="text-hcolor text-sm lg:text-base">Color: {item.selectedColor || "Default"}</p>
      <p className="text-hcolor text-sm lg:text-base">Quantity: {item.quantity}</p>
      
      {/* Move price below quantity on small & medium screens */}
      <p className="text-sm lg:hidden font-semibold text-hcolor mt-1">Rs. {parseFloat(item.discountedPrice).toFixed(2)}</p>
    </div>

    {/* Keep price on the right side for large screens */}
    <p className="hidden lg:block text-lg font-semibold text-hcolor">Rs. {parseFloat(item.discountedPrice).toFixed(2)}</p>
  </div>
)) : <p className="text-hcolor">No items in this order.</p>}

      </div>
    </div>
    <div>
    <hr className="border-secondary my-2" />
              <div className="py-4 px-6">
                <p className="text-sm lg:text-base font-poppins text-hcolor flex font-light">
                  Subtotal: <span className="ml-auto text-right">Rs.{(order.totalPrice - order.gst).toFixed(2)}INR</span>
                </p>
                <p className="text-sm lg:text-base font-poppins text-hcolor flex font-light">
                  GST (18%): <span className="ml-auto text-right">+ Rs.{order.gst}INR</span>
                </p>
                
                  <p className="text-sm lg:text-base font-poppins text-hcolor flex font-light">
                    Coupon Discount: <span className="ml-auto">- Rs.{order.couponDiscount.toFixed(2)}INR</span>
                  </p>
                
              </div>

    </div>

    <div className="py-5 flex flex-col text-xl  font-semibold border-secondary border-t ">
      <div className="px-6">
      <div className="flex justify-between">
    <span className="text-primary1">Total</span>
    <span className="text-hcolor">Rs. {order.totalPrice} INR</span>
  </div>
  <div className="text-sm text-hcolor text-left font-light font-poppins">
    Including Rs. {order.gst} INR in Taxes
  </div>
</div>
      </div>
 

  </div>
</div>

      </div>
      <FooterDoodles />
      <Footer />
      
    </>
  );
};

export default OrderDetail;
